import {Pressable, StyleSheet, Text, View, ViewStyle} from "react-native";
import {Color} from "@/lib/styles";
import {chat} from "@/lib/proto";
import {useMemo, useState} from "react";
import {useAccount} from "@/lib/providers/AccountProvider";
import ProtoAvatar = chat.Avatar;
import PrimaryText from "@/lib/components/PrimaryText";

type Props = {
    emoji: string,
    avatars: ProtoAvatar[],
    onPress?: (emoji: string) => any,
}

export default function ChatReaction({emoji, avatars, onPress}: Props) {
    const {account} = useAccount();

    const [hover, setHover] = useState(false);

    const selfInAvatars = useMemo(() => {
        return account !== undefined &&
            avatars !== undefined &&
            avatars.findIndex((avatar) => account.avatar.id === avatar.id) !== -1;
    }, [avatars, account]);

    const containerStyle: ViewStyle = selfInAvatars ? {
        outlineWidth: 1,
        outlineStyle: "solid",
    } : {};

    return (
        <>
            {hover &&
                <View style={styles.reactionFromNames}>
                    {avatars.map(avatar => <PrimaryText key={avatar.id}>{avatar.gecos}</PrimaryText>)}
                </View>
            }
            <Pressable
                style={[styles.container, containerStyle]}
                onPress={() => onPress?.(emoji)}
                onHoverIn={() => setHover(true)}
                onHoverOut={() => setHover(false)}
            >
                <Text style={styles.emoji} selectable={false}>{emoji}</Text>
                <Text style={styles.counter} selectable={false}>{avatars.length}</Text>
            </Pressable>
        </>
    );
}

export const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        borderRadius: 32,
        backgroundColor: Color.BackgroundContainer + '40',
        outlineColor: Color.BorderStrong + '80',
        gap: 2,
        height: 22,
        alignItems: "center",
        padding: 2,
        paddingRight: 4,
    },
    emoji: {
        fontSize: 18,
    },
    counter: {
        fontSize: 10,
        fontWeight: 600,
        color: Color.PrimaryText,
    },
    reactionFromNames: {
        overflow: "visible",
        backgroundColor: Color.BackgroundContainer,
        position: "absolute",
        flexDirection: "column",
        padding: 6,
        borderRadius: 8,
        minWidth: 100,
        gap: 4,
        top: -34,
        right: 0,
    },
})